module.exports = __webpack_public_path__ + "img/timg.80801ff8.jpg";